import { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import classes from "./index.module.scss";
import parser from "fast-xml-parser";

type Props = {
  tooltipData: Tooltip | null;
};

type Coordinate = [number, number];
export type Tooltip = {
  sensorName: string;
  lastReading: number;
  coordinates: Coordinate;
};

const MapTooltip = (props: Props) => {
  const { tooltipData } = props;
  const [address, setAddress] = useState<string[]>([]);

  useEffect(() => {
    ReactTooltip.rebuild();
    const reverseGeoCoordinates = async () => {
      const { coordinates } = tooltipData as Tooltip;
      await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${coordinates[1]}&lon=${coordinates[0]}`
      )
        .then((res) => res.text())
        .then((xmlData) => {
          const data = parser.parse(xmlData);
          const addressArray = [
            data.reversegeocode.addressparts.neighbourhood,
            data.reversegeocode.addressparts.city,
            data.reversegeocode.addressparts.state,
            data.reversegeocode.addressparts.country,
          ];
          setAddress(addressArray.filter(el => el !== undefined));
        });
    };

    if (tooltipData) {
      reverseGeoCoordinates();
    }
  }, [tooltipData]);

  const formatSensorReading = (reading: number): string => {
    const wholeNumberLabel = Math.trunc(reading) || "000";
    const stringLabel = wholeNumberLabel.toString();

    if (stringLabel.length === 2) return `0${stringLabel}`;
    else if (stringLabel.length === 1) return `00${stringLabel}`;
    return stringLabel;
  };

  return (
    <ReactTooltip>
      {tooltipData !== null && (
        <>
          <div className={classes.section}>
            <p className={classes.sectionTitle}>Last reading:</p>
            <div>
              {tooltipData?.sensorName.toUpperCase()}{" "}
              {formatSensorReading(tooltipData?.lastReading)}
            </div>
          </div>
          <div className={classes.section}>
            <p className={classes.sectionTitle}>Location:</p>
            <div>
              {address.join(", ")}
            </div>
          </div>
        </>
      )}
    </ReactTooltip>
  );
};

export default MapTooltip;
